import clsx from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './IconButton.module.css';

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'aria-label'> {
  children: ReactNode;
  label: string;
  active?: boolean;
}

export function IconButton({
  children,
  label,
  active = false,
  type = 'button',
  className,
  title,
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      className={clsx(styles.iconButton, active && styles.active, className)}
      aria-label={label}
      title={title ?? label}
      aria-pressed={active || undefined}
      {...rest}
    >
      {children}
    </button>
  );
}
